import { skipToken, useQuery } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { coordinationEndpoints } from '@/modules/coordination/constants';

import { coordinationQueryKeys } from './queryKeys';

export const useCoordinationProcessDetailQuery = (
  jobId: string | undefined,
  coordinationProcessId: string | undefined,
) => {
  return useQuery({
    queryKey:
      jobId && coordinationProcessId
        ? coordinationQueryKeys.processDetail(jobId, coordinationProcessId)
        : [],
    queryFn:
      jobId && coordinationProcessId
        ? async () => {
            const { data } = await fetchClient.GET(
              coordinationEndpoints.processDetail,
              {
                params: { path: { jobId, coordinationProcessId } },
              },
            );
            return data;
          }
        : skipToken,
  });
};
